/*
 * Mucky Shopify Theme — minimal JS
 */
document.addEventListener('DOMContentLoaded', function () {

  // Quantity selectors
  document.querySelectorAll('.quantity-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var wrapper = this.closest('.quantity-selector');
      var input = wrapper.querySelector('.quantity-input');
      var val = parseInt(input.value) || 1;
      if (this.classList.contains('qty-plus')) {
        input.value = val + 1;
      } else if (this.classList.contains('qty-minus')) {
        input.value = Math.max(1, val - 1);
      }
    });
  });

  // Newsletter form — use Mailchimp action if configured
  var newsForm = document.querySelector('.newsletter-form');
  if (newsForm) {
    var action = newsForm.getAttribute('data-action');
    if (action) {
      newsForm.setAttribute('action', action);
      newsForm.setAttribute('method', 'post');
      newsForm.setAttribute('target', '_blank');
    }
  }

});
